/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IRAlimentacao } from '../../../shared/services/api/rh/Relatorios/RelatoriosService';
 

async function RelatorioAlimentacao(dados: IRAlimentacao[], periodo: string, fazenda: string){
  
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const TAlmoco = dados.reduce((acc, item) => acc + item.almoco, 0);
  const TJanta = dados.reduce((acc, item) => acc + item.janta, 0);
  const TCafe = dados.reduce((acc, item) => acc + item.cafe, 0);
  const TTotal = dados.reduce((acc, item) => acc + item.total, 0);


  const rows = dados.map((row) => {
    return [
      {text: row.nome, alignment: 'left',  fontSize: 10},
      {text: row.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'), alignment: 'left',  fontSize: 10},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.almoco), alignment: 'right',  fontSize: 10},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.janta), alignment: 'right',  fontSize: 10},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.cafe), alignment: 'right',  fontSize: 10},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.total), alignment: 'right',  fontSize: 10},
    ]; 
  });  

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';   
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas'); 
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  window.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const documentDefinition : any = {
    pageSize: 'A4',
    pageMargins: [10, 30, 10, 10],
    header: '',
    content: ([
      {   
        table: {
          body: [
            [ 
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],  
                table: {
                  widths: [500],
                  body: [
                    [ 
                      {text: window.env.REACT_APP_URL_EMPRESA, fontSize: 16,  margin: [0, 5, 0, 0], bold: true, color: '#FFFFFF',  alignment: 'center', fillColor: '#00A47B', border: [false, false, false, false]},
                    ],
                    [ 
                      {text: window.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true]},
                    ],
                  ]
                }
              },
              
            ],
            [
              {text: 'Relatório Alimentação', colSpan: 2, margin: [5, 10, 0, 0], fontSize: 18, bold: true,  alignment: 'center',  border: [false, false, false, false]},
              {}
            ]
          ]
        } 
      },
      {text: 'Fazenda: ' + fazenda, alignment: 'center',  fontSize: 13},
      {text: 'Periodo: ' + periodo, fontSize: 14},
      {  
        table:{
          widths: [200, 80, 60, 60, 60, 60],
          headerRows: 1,
          body: [
            [
              {text: 'Colaborador',  style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10},
              {text: 'CPF',  style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10},
              {text: 'Almoço', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10},
              {text: 'Janta', style: 'tableHeader',  alignment: 'center', fillColor: '#dddddd', fontSize: 10},
              {text: 'Cafe', style: 'tableHeader',  alignment: 'center', fillColor: '#dddddd', fontSize: 10},
              {text: 'Total', style: 'tableHeader',  alignment: 'center', fillColor: '#dddddd', fontSize: 10},
            ],
            ...rows, 
            [
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TAlmoco), alignment: 'right',  fillColor: '#dddddd', fontSize: 10, bold: true},
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TJanta), alignment: 'right',  fillColor: '#dddddd', fontSize: 10, bold: true},
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TCafe), alignment: 'right',  fillColor: '#dddddd', fontSize: 10, bold: true},
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TTotal), alignment: 'right',  fillColor: '#dddddd', fontSize: 10, bold: true},
            ]
          ]
        },
      },   
    ]),
      
  };
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}
export default RelatorioAlimentacao;

